<template>
<div style="margin-bottom: 15px;">
  <div class="columns" v-show="!isEditing" v-bind:class="showActiveBorder(data.status)">
      <div class="column is-three-quarters">
        <p class="subtitle" v-on:click="viewSubmissions(data.id,data.name)" style="cursor: pointer">
          {{ data.name }}
        </p>
      </div>
      <div class="column is-one-quarter">
        <div class="field has-addons" style="float: right">
          <div class='extra content'>
            <a class="button is-info is-outlined is-small" v-on:click="viewSubmissions(data.id,data.name)">
              View Submissions
            </a>
            <a class="button is-info is-outlined is-small" v-on:click="viewSubmissionsInExcel(data.id,data.name)">
              Download In Excel
            </a>
            <a class="button is-info is-outlined is-small" v-on:click="displayLinkQRPage(data.template,data.id,data.name)">
              Display Form Link/QR
            </a>
            <a class="button is-info is-outlined is-small" v-on:click="edit(data)">
              Edit
            </a>
            <a class="button is-info is-outlined is-small" v-on:click="deleteData(data)">
              Remove
            </a>
            <!-- <span class='right floated icon' v-on:click="viewSubmissions(data.id,data.name)">
                <font-awesome-icon icon="calendar" />
            </span>
            <span class='right floated icon' v-on:click="viewSubmissionsInExcel(data.id,data.name)">
                <font-awesome-icon icon="file-excel" />
            </span> -->
            <!-- <span class='right floated icon' v-on:click="displayLinkQRPage(data.template,data.id,data.name)">
                <font-awesome-icon icon="qrcode" />
            </span>
            <span class='right floated icon' v-on:click="edit(data)">
                <font-awesome-icon icon="edit" />
            </span>
            <span class='right floated icon' v-on:click="deleteData(data)">
              <font-awesome-icon icon="trash-alt" />
            </span> -->
          </div>
        </div>
      </div>
  </div>
  <div class="columns" style="margin-bottom: 10px;" v-show="isEditing">
    <div class="column is-5">
      <p class="control">
        <input class="input" type="text" placeholder="e.g Visitor's Form" v-model="data.name" name="updateName">
      </p>
    </div>
    <div class="column is-3">
      <p class="control">
        <input class="input" type="number" placeholder="1 - 20" v-model="data.fieldCount" @change="updateFieldCount()" @click="updateFieldCount()">
      </p>
    </div>
    <div class="column is-2">              
      <div class="field" style="margin-top: 5px;">
        <div class="control">
            <label class="radio">
                <input type="radio" :name="data.status" v-model="data.status" value="1" >
                Active
            </label>
            <label class="radio">
                <input type="radio" :name="data.status" v-model="data.status" value="0">
                Inactive
            </label>
        </div>
      </div>
    </div>
    <div class="column is-2">
        <button class='button is-primary' v-on:click="hideForm(data)">OK</button>
        <button class="button is-warning" v-on:click="closeForm()">X</button>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
    props: ['data'],
    data() {
        return {
            isEditing: false,
        };
    },
    created() {
    },
    methods: {
      showActiveBorder(isActive){
        if (isActive == "1"){
          return "status-active-contents";
        }else{          
          return "status-inactive-contents";
        }
      },
      deleteData(data) {
          this.$emit('delete-data', data);
      },
      viewSubmissions(id,name){        
        this.$store.commit('UPDATE_FORM_ID',id)
        this.$store.commit('UPDATE_FORM_NAME',name)
        localStorage.setItem('FORM_ID',id)
        localStorage.setItem('FORM_NAME',name)
        this.$router.push({
            name: "DbFormSubmissionList"
        });
      },
      viewSubmissionsInExcel(id,name){        
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        // axios.defaults.responseType = 'blob'
        axios.defaults.responseType = 'json'
        axios.defaults.timeout = 0
        axios.post(process.env.NEW_ENDPOINT + '/form/listSubmissionsInExcel', {
                loginEmail: localStorage.getItem('email'),
                token: localStorage.getItem('newToken'),
                schoolId: localStorage.getItem('schoolID'),
                country: localStorage.getItem('country'),
                formId: id
            })
           .then(response => {
              console.log("109 response")
              console.log(response.data)

              window.location.href = response.data.url
              // const url = window.URL.createObjectURL(new Blob([response.data]));
              // const link = document.createElement('a');
              // link.href = url;
              // link.setAttribute('download', name + "_submissions.xlsx"); 
              // document.body.appendChild(link);
              // link.click();
            })
            .catch(e => {
                console.log(e)
            })
      },
      edit(data){
        console.log("entering edit with data")
        console.log(data.id)
        console.log(data.name)
        this.$store.commit('UPDATE_FORM_ID',data.id)
        this.$store.commit('UPDATE_FORM_NAME',data.name)
        this.$store.commit('UPDATE_FORM_STATUS',data.status)
        this.$store.commit('UPDATE_FORM_FIELDS',data.content)
        localStorage.setItem('FORM_ID',data.id)
        localStorage.setItem('FORM_NAME',data.name)
        localStorage.setItem('FORM_STATUS',data.status)
        localStorage.setItem('FORM_FIELDS',data.content)
        this.$router.push({
            name: "DbFormUpdate"
        });
      },
      displayLinkQRPage(template,id,name){
        var country = localStorage.getItem('country')
        var schoolNo = localStorage.getItem('schoolNo')
        let routeData = this.$router.resolve({name: 'DbFormDisplayLinkQR', query: {country: country, schoolNo: schoolNo, template: template, id: id, name: name}});
        window.open(routeData.href, '_blank');
      },
      hideForm(data) {
          this.$emit('update-data', data);

          this.isEditing = false;
      },
      closeForm(){
        this.isEditing = false;
      },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Database/Form/DataView.vue